export function resolvePostRefreshWorkspaceSelection(params: {
    workspaces: Array<{ id: string }>;
    currentWorkspaceId: string | null;
    pendingPaymentWorkspaceId: string | null;
    preferredWorkspaceId: string | null;
}): string | null {
    const preferredWorkspaceId = params.preferredWorkspaceId?.trim() || null;

    if (preferredWorkspaceId) {
        const preferredWorkspaceExists = params.workspaces.some((workspace) => workspace.id === preferredWorkspaceId);
        return preferredWorkspaceExists ? preferredWorkspaceId : null;
    }

    const pendingPaymentWorkspaceId = params.pendingPaymentWorkspaceId?.trim() || null;
    if (pendingPaymentWorkspaceId) {
        const pendingPaymentWorkspaceExists = params.workspaces.some((workspace) => workspace.id === pendingPaymentWorkspaceId);
        return pendingPaymentWorkspaceExists ? pendingPaymentWorkspaceId : null;
    }

    if (params.currentWorkspaceId || params.workspaces.length === 0) {
        return null;
    }

    return params.workspaces[0].id;
}

export function shouldRedirectToOnboardingAfterRefresh(params: {
    workspaceCount: number;
    skipEmptyRedirect?: boolean;
    pendingPasswordSetup?: boolean;
    pendingWorkspaceReturn?: boolean;
    suppressEmptyWorkspaceRedirect?: boolean;
}): boolean {
    if (params.pendingPasswordSetup) {
        return false;
    }

    if (params.pendingWorkspaceReturn) {
        return false;
    }

    if (params.suppressEmptyWorkspaceRedirect) {
        return false;
    }

    return params.workspaceCount === 0 && !params.skipEmptyRedirect;
}

const EMPTY_WORKSPACE_ONBOARDING_SUPPRESSED_OAUTH_ROUTES = [
    '/admin/oauth/success',
    '/admin/oauth/client-return',
    '/oauth/success',
    '/oauth/client-return',
];

export function shouldSuppressEmptyWorkspaceOnboardingRedirect(pathname: string): boolean {
    const normalizedPathname = pathname.trim().replace(/\/+$/, '') || '/';
    return EMPTY_WORKSPACE_ONBOARDING_SUPPRESSED_OAUTH_ROUTES.some((route) => (
        normalizedPathname === route || normalizedPathname.startsWith(`${route}/`)
    ));
}
